import { createSlice } from '@reduxjs/toolkit'
import saveDataToLocalStorage, {setLocalStorage} from '../../core/utils/saveDataToLocalStorage.js';
import {apiUrl} from '@/api/axios.js';
import {handleResponseError} from '@/core/utils/handleResponseError.js';
import {getTranslation} from '@/core/utils/i18nHelper';

const initialState = {
    likes: [],
    localStorageKey: '',
    reactionState: 0,
    isFetching: true,
    activeButton: '',
    likesResponse: null,
    successMessage: null,
    error: null,
}

const likesSlice = createSlice({
    name: 'likes',
    initialState,
    reducers: {
        setLikesLocalStorageKey(state, action) {
            state.localStorageKey = action.payload
        },

        updateLikes(state, action) {
            state.likes = [...action.payload]
        },

        postLikesError(state, action) {
            state.isFetching = false
            state.error = action.payload
        },

        postLikesLoaded(state, action) {
            state.isFetching = false
            state.likesResponse = action.payload
        },

        likesSent(state, action) {
            state.successMessage = action.payload;
            state.error = null;
        },

        setReactionState(state, action) {
            state.reactionState = action.payload
        },

        resetReactionState(state) {
            state.reactionState = 0
        },

        setActiveButton(state, action) {
            state.activeButton = action.payload
        },

        setError(state, action) {
            state.error = action.payload;
        },

        resetLikesState(state) {
            state.likes = [];
            state.activeButton = '';
            state.likesResponse = null;
            state.error = null;
        }
    },
});

export const {
    setLikesLocalStorageKey,
    updateLikes,
    postLikesStart,
    postLikesLoaded,
    postLikesError,
    setReactionState,
    resetReactionState,
    setActiveButton,
    setError,
    likesSent,
    resetLikesState,
} = likesSlice.actions;

export default likesSlice.reducer;


export function setLikesData(key) {
    return (dispatch, getState) => {
        const storedLikes = JSON.parse(localStorage.getItem(key)) || [];
        dispatch(updateLikes(storedLikes));

        const activeQuestion = getState().testing.activeQuestion;
        const currentQuestionId = getState().testing.testData[activeQuestion]?.id;
        const reactionState = getState().likes.reactionState;
        dispatch(findIfLiked(currentQuestionId));

        dispatch(setActiveButton(reactionState === 1 ? 'like' : (reactionState === -1 ? 'dislike' : '')));
    };
}

export function likeClick(reaction, question_id) {
    return (dispatch, getState) => {
        const localStorageKey = getState().likes.localStorageKey;
        const likes = getState().likes.likes;

        if (reaction === 0) {
            const updatedLikes = likes.filter(item => item.question_id !== question_id);
            setLocalStorage(localStorageKey, updatedLikes);
            dispatch(updateLikes(updatedLikes));
            dispatch(setActiveButton(''))
            dispatch(resetReactionState())
        } else {
            let newLikeItem = {
                reaction: reaction,
                question_id: question_id
            };

            saveDataToLocalStorage(localStorageKey, newLikeItem,updatedLikes => {
                dispatch(updateLikes(updatedLikes));
            });


        }
    };
}

export function findIfLiked(currentQuestionId) {
    return (dispatch, getState) => {
        const likes = getState().likes.likes;

        const like = likes.find(item => item.question_id === currentQuestionId);

        if (like) {
            if(like.reaction === 1) {
                dispatch(setReactionState(1))
            } else {
                dispatch(setReactionState(-1))
            }
        } else {
            dispatch(setReactionState(0))
        }

    }
}


export function sendLikes(likes, attemptKey) {
    return async function sendLikesThunk(dispatch) {
        const data = {
            attempt_key: attemptKey,
            likes: likes
        }

        dispatch(postLikes(data))
    }
}

export const postLikes = (data) => async (dispatch) => {
    const successMessage = getTranslation('report.sent');
    try {
        const response = await apiUrl.post('api/questions/likes', data)
        dispatch(postLikesLoaded(response.data))
        dispatch(likesSent(successMessage))
    } catch (error) {
        handleResponseError(error, (data) => dispatch(setError(data)))
    }
}

